import { getBackendUrl } from "@Utils";
import i18n from "@i18n";
import axiosWrapper from "../../../../services/axiosWrapper";
export { setWorkflowResourceType } from "../../../../reducers/Workflows";

const { t } = i18n;

export interface ApiResponse<T = any> {
  data: T;
  status: number;
  [key: string]: any;
}

export interface TemplateArgs {
  createdByTemplate?: any;
  createdDateTemplate?: any;
  statusFromTemplate?: any;
  statusToTemplate?: any;
  reviewLevelsTemplate?: any;
  reviewLevelTemplate?: any;
  reviewersTemplate?: any;
  reviewLevelFilterTemplate?: any;
}

export interface ToolbarTemplateArgs {
  [key: string]: any;
}

export const saveWorkflow = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/saveWorkflow`, data);

export const deleteWorkflows = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/deleteWorkflows`, data);

export const saveReviewLevel = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/saveReviewLevel`, data);

export const fetchWorkflowLevels = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/workflowReviewLevelsService`, data);

export const fetchreviewsUrl = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/reviews/reviewsService`, data);

export const fetchchecklistData = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/reviews/getChecklists`, data);

export const getReviewLevelData = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/getWorkflowReviewLevelData`, data);

export const addReviewerToLevel = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/addReviewerToLevel`, data);

export const addInitiatorToWorkflow = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/addInitiatorToWorkflow`, data);

export const removeReviewerFromLevel = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/removeReviewerFromLevel`, data);

export const removeInitiatorFromWorkflow = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/removeInitiatorFromWorkflow`, data);

export const duplicateWorkflow = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/duplicateWorkflow`, data);

export const changeArchivedWorkflowStatus = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/changeArchivedWorkflowStatus`, data);

export const addReviewFlowsToLibrary = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/addReviewFlowsToLibrary`, data);

export const saveTransition = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/saveTransition`, data);

export const getPortalLevelStatusList = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/portal/getPortalLevelStatusList`, data);

export const getTransition = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/getTransition`, data);

export const getTransitionsList = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/transitionsService`, data);

export const getStatusListInWorkflow = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/getStatusListInWorkflow`, data);

export const getStatusListInTransitions = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/getStatusesInTransitions`, data);

export const saveWorkflowStatusList = async (data: any): Promise<ApiResponse> =>
  await axiosWrapper.post(`${getBackendUrl()}/workflows/saveWorkflowStatusList`, data);

// ---------- GRID COLUMNS ----------

export const workflowGridColumns = ({ createdByTemplate, createdDateTemplate }: TemplateArgs) => [
  {
    type: "checkbox",
    width: "30",
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    field: "_id",
    headerText: "",
    width: "0",
    visible: false,
    showInColumnChooser: false,
    isPrimaryKey: true,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    field: "name",
    headerText: t("Name"),
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "description",
    headerText: t("Description"),
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "createdBy",
    headerText: t("Created by"),
    type: "string",
    template: createdByTemplate,
    editTemplate: createdByTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "createdDate",
    headerText: t("Created On"),
    template: createdDateTemplate,
    editTemplate: createdDateTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: true,
  },
];

// ---------- TOOLBARS ----------

export const getWorkflowToolbar = ({
  editBtnTemplate,
  deleteBtnTemplate,
  duplicateBtnTemplate,
  propertiesBtnTemplate,
  addToLibraryBtnTemplate,
  craeteReviewFlowCopyBtnTemplate,
  archiveBtnTemplate,
  viewArchiveAndUnarchiveWorkflowTemplate,
  isArchived,
}: ToolbarTemplateArgs & { isArchived: boolean }) => {
  const toolbar: any[] = [];

  if (!isArchived) {
    toolbar.push(
      { id: "create_review_flow_copy_dropdown", align: "Left", template: craeteReviewFlowCopyBtnTemplate },
      { id: "edit_workflow", align: "Left", template: editBtnTemplate },
      { id: "delete_workflow", align: "Left", template: deleteBtnTemplate },
      { id: "duplicate_workflow", align: "Left", template: duplicateBtnTemplate },
      { id: "archive_workflow", align: "Left", template: archiveBtnTemplate },
      { id: "add_to_library", align: "Left", template: addToLibraryBtnTemplate },
    );
  } else {
    toolbar.push(
      { id: "delete_workflow", align: "Left", template: deleteBtnTemplate },
      { id: "archive_workflow", align: "Left", template: archiveBtnTemplate },
    );
  }

  toolbar.push(
    { id: "view_Archive_And_Unarchive_Workflow", align: "Right", template: viewArchiveAndUnarchiveWorkflowTemplate },
    { id: "workflow_properties", template: propertiesBtnTemplate, align: "Right" },
    "ColumnChooser",
  );

  return toolbar;
};

export const getTransitionsToolbar = ({
  createBtnTemplate,
  editBtnTemplate,
  deleteBtnTemplate,
  propertiesBtnTemplate,
}: ToolbarTemplateArgs) => [
  { id: "create_transition", align: "Left", template: createBtnTemplate },
  { id: "edit_transition", align: "Left", template: editBtnTemplate },
  { id: "delete_transition", align: "Left", template: deleteBtnTemplate },
  { id: "transition_properties", template: propertiesBtnTemplate, align: "Right" },
  "ColumnChooser",
];

export const transitionsGridColumns = ({
  statusFromTemplate,
  statusToTemplate,
  reviewLevelsTemplate,
}: TemplateArgs) => [
  {
    type: "checkbox",
    width: "40",
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    width: 0,
    field: "_id",
    headerText: "",
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
    showInColumnChooser: false,
    isPrimaryKey: true,
    visible: false,
  },
  {
    field: "name",
    headerText: t("Transition Name"),
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "description",
    headerText: t("Description"),
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "statusFrom",
    headerText: t("From Status"),
    template: statusFromTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    field: "statusTo",
    headerText: t("To Status"),
    template: statusToTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    field: "levels",
    headerText: t("Levels"),
    width: "350",
    template: reviewLevelsTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
];

export const getReviewLevelsGridColumns = ({
  reviewLevelTemplate,
  reviewersTemplate,
  reviewLevelFilterTemplate,
}: TemplateArgs) => [
  {
    type: "checkbox",
    width: "25",
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
  {
    width: 0,
    field: "_id",
    headerText: "",
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
    showInColumnChooser: false,
    isPrimaryKey: true,
    visible: false,
  },
  {
    field: "serial",
    headerText: t("Review Levels"),
    filter: { type: "Menu" },
    width: "50",
    type: "number",
    template: reviewLevelTemplate,
    filterTemplate: reviewLevelFilterTemplate,
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "title",
    width: "80",
    headerText: t("Level Title"),
    allowFiltering: true,
    allowEditing: false,
    allowSorting: true,
  },
  {
    field: "reviewers",
    headerText: t("Reviewers"),
    template: reviewersTemplate,
    allowFiltering: false,
    allowEditing: false,
    allowSorting: false,
  },
];

export const getWorkflowReviewLevelsToolbar = ({
  createBtnTemplate,
  editBtnTemplate,
  deleteBtnTemplate,
  propertiesBtnTemplate,
}: ToolbarTemplateArgs) => [
  { id: "create_review_level", template: createBtnTemplate, align: "Left" },
  { id: "edit_review_level", template: editBtnTemplate, align: "Left" },
  { id: "delete_review_level", template: deleteBtnTemplate, align: "Left" },
  { id: "review_level_properties", template: propertiesBtnTemplate, align: "Right" },
  "ColumnChooser",
];

// ---------- LEVEL STATE HELPERS ----------

interface Reviewer {
  userId: string;
  isReviewerSelected: boolean;
}

interface ReviewLevel {
  _id: string;
  title?: string;
  reviewers: Reviewer[];
  levelSelectionState: "empty" | "partial" | "complete";
  [key: string]: any;
}

export const levelCheckboxChange = (
  reviewLevels: ReviewLevel[],
  targetLevelId: string,
): { levelsUpdated: ReviewLevel[]; areReviewLevelsValid: boolean } => {
  let areReviewLevelsValid = false;

  const levelsUpdated = reviewLevels.map((level) => {
    const { _id, levelSelectionState, reviewers } = level;

    if (_id !== targetLevelId) {
      if (["partial", "complete"].includes(levelSelectionState)) areReviewLevelsValid = true;
      return level;
    }

    if (["empty", "partial"].includes(levelSelectionState)) {
      const updatedReviewers = reviewers.map((r) => ({ ...r, isReviewerSelected: true }));
      areReviewLevelsValid = true;
      return { ...level, levelSelectionState: "complete" as const, reviewers: updatedReviewers };
    }

    if (levelSelectionState === "complete") {
      const updatedReviewers = reviewers.map((r) => ({ ...r, isReviewerSelected: false }));
      return { ...level, levelSelectionState: "empty" as const, reviewers: updatedReviewers };
    }

    return level;
  });

  return { levelsUpdated, areReviewLevelsValid };
};

const calculateLevelSelectionState = (
  reviewersSelected: Reviewer[],
  updatedReviewers: Reviewer[],
): "empty" | "partial" | "complete" => {
  if (!reviewersSelected.length) return "empty";
  if (reviewersSelected.length < updatedReviewers.length) return "partial";
  return "complete";
};

export const reviewerCheckboxChange = (
  reviewLevels: ReviewLevel[],
  targetLevelId: string,
  userId: string,
): { levelsUpdated: ReviewLevel[]; areReviewLevelsValid: boolean } => {
  let areReviewLevelsValid = false;

  const levelsUpdated = reviewLevels.map((level) => {
    const { _id, reviewers, levelSelectionState } = level;

    if (_id !== targetLevelId) {
      if (["partial", "complete"].includes(levelSelectionState)) areReviewLevelsValid = true;
      return level;
    }

    const updatedReviewers = reviewers.map((r) =>
      r.userId === userId ? { ...r, isReviewerSelected: !r.isReviewerSelected } : r,
    );

    const reviewersSelected = updatedReviewers.filter((r) => r.isReviewerSelected);
    const updatedState = calculateLevelSelectionState(reviewersSelected, updatedReviewers);

    if (["partial", "complete"].includes(updatedState)) areReviewLevelsValid = true;

    return { ...level, levelSelectionState: updatedState, reviewers: updatedReviewers };
  });

  return { levelsUpdated, areReviewLevelsValid };
};
